<template>
  <v-container>
    <v-lov-dialog title="选择用户" :width="800"
                  :fields="userRoleLovFields"
                  query-api="ROLE_QUERY"
                  v-model="showRoleLovDialog"
                  @cancel="showRoleLovDialog=false"
                  @ok="onAddRoleUser"></v-lov-dialog>
    <v-simple-form title="用户信息">
      <template v-slot:toolbar>
        <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
          <v-icon color="gray">mdi-step-backward</v-icon>
          返回
        </v-btn>
        <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
          <v-icon color="gray">mdi-content-save</v-icon>
          保存
        </v-btn>
        <v-spacer/>
      </template>
      <template v-slot:content>
        <v-form-field x-large v-model="dataItem.displayName" label="姓名"></v-form-field>
        <v-form-field x-large v-model="dataItem.userId" label="登录账号" tip="默认手机号"></v-form-field>
        <v-form-field x-large v-model="dataItem.email" label="邮箱"></v-form-field>
        <v-form-field x-large v-model="dataItem.phone" label="手机号"></v-form-field>
        <v-form-field password x-large v-model="dataItem.password" label="密码"></v-form-field>
        <v-form-selector :clearable="false" v-model="dataItem.sex" label="性别"
                         items="男|M,女|F"></v-form-selector>
        <v-form-selector :clearable="false" v-model="dataItem.type" label="工厂"
                         items="邦威|1,帮登|2,鸿森|3,足友|4,越南|5,备用工厂|6"></v-form-selector>
        <v-form-switch :true-value="1" :false-value="0" v-model="dataItem.state" label="启用"></v-form-switch>
      </template>
    </v-simple-form>
    <v-simple-form title="所属角色" v-if="docId">
      <template v-slot:toolbar>
        <v-btn text tile small color="rgba(0,0,0,.7)" @click="showRoleLovDialog=true">
          <v-icon color="gray">mdi-plus-circle</v-icon>
          添加角色
        </v-btn>
        <v-spacer/>
      </template>
      <template v-slot:content>
        <v-page-data-table
            hide-toolbar
            title=""
            key-name="id"
            ref="userRole"
            :fields="userRoleFields"
            :show-edit="false"
            :query-params="userRoleQueryParams"
            query-api="USER_ROLE_LIST"
            delete-api="ROLE_USER_REMOVE">
        </v-page-data-table>
      </template>
    </v-simple-form>

    <v-simple-form title="所属组织" v-if="false">
      <template v-slot:toolbar>
        <v-btn text tile small color="rgba(0,0,0,.7)">
          <v-icon color="gray">mdi-plus-circle</v-icon>
          添加组织
        </v-btn>
        <v-spacer/>
      </template>
      <template v-slot:content>
        <v-page-data-table
            hide-toolbar
            title=""
            key-name="id"
            ref="routing"
            hide-row-action
            hide-footer
            :fields="userOrgFields"
            :show-edit="false"
            :expand-row-column-count="1"
            :data-items="dataItem.orgs">

        </v-page-data-table>
      </template>
    </v-simple-form>
  </v-container>
</template>

<script>

import FndUserRoleFields from "./fields/FndUserRole";
import FndUserOrgFields from "./fields/FndUserOrg"
import FndUserRoleLovFields from "./fields/FndUserRoleLov"

export default {
  name: "ProjectDetail.vue",
  data() {
    return {
      docId: null,
      userRoleFields: FndUserRoleFields,
      userOrgFields: FndUserOrgFields,
      userRoleLovFields: FndUserRoleLovFields,
      showRoleLovDialog: false,
      userRoleQueryParams: {
        userId: this.$route.query.id
      },
      dataItem: {
        id: null,
        displayName: null,
        email: null,
        phone: null,
        userId: null,
        type: null,
        sex: 'M',
        state: 1,
        password: null,
        roles: [],
        orgs: []
      }
    }
  },
  created() {
    this.docId = this.$route.query.id;
    if (this.docId) {
      this.queryDetail(this.docId);
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onSave() {
      if (this.dataItem.password == '12345') {
        delete this.dataItem.password;
      }
      this.$request
          .request("USER_APPLY", this.dataItem)
          .then((response) => {
            this.$message.success("保存成功");
            if (!this.docId) {
              this.goBack();
            }
          });
    },

    queryDetail(id) {
      this.$request
          .request("USER_DETAIL", {rowid: id})
          .then(response => {
            this.dataItem = response.data;
            this.dataItem.password = '12345';
          });
    },
    onAddRoleUser(item) {
      let parameter = {
        userId: this.docId,
        roleId: item.id
      }
      this.$request
          .request("ROLE_USER_ADD", parameter)
          .then((response) => {
            this.$refs.userRole.query();
          });
      this.showRoleLovDialog = false;
    }
  }
}
</script>
